<template>
    <transition name="confirm-fade">
        <div v-if="isShowConfirm" class="my-confirm" @click.stop="hidden()">
            <div :class="['wrap', { 'container-dark': theme_dark }]" @click.stop>
                <h3 class="title">封号提醒</h3>

                <div class="content">
                    <div class="txt ub ub-pc">
                        <div>
                            你已被系统封禁，封禁原因：<span>{{ kill_info.reason }}</span>;
                            封禁时长：<span>{{ kill_info.hour }} 小时</span>;
                            预计自动解封时间：<span>{{ kill_info.dtm_unkill }}</span>;
                            在封禁期间你将被限制聊天功能。你也可以选择手动解封，手动解封需要支付：<span>{{ kill_info.pay_coin }}金币</span>;
                            确定手动解封，点击立即解封按钮";
                        </div>"
                    </div>

                    <div class="oper ub ub-ac3">
                        <div class="btn cancel  ub ub-ac ub-pc" @click="hidden()">
                            <span>取消</span>
                        </div>
                        <div class="btn ok ub ub-ac ub-pc" @click="unseal()">
                            <span>立即解封</span>
                        </div>
                    </div>
                </div>

            </div>
            <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
        </div>
    </transition>
</template>

<script >
import * as tool from '../api/common';
import { mapMutations, mapActions } from "vuex";
import Alert from "../components/Alert.vue";
      export default {
        components: {
            alert: Alert,
        },
        data () {
          return {
            isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
            theme_dark: false,
            kill_info: {
                "reason": "",
                "hour": "",
                "dtm_unkill":"",
                "pay_coin": ""
            },
            user_info: {
                "coin_left": 0
            }
          }
        },
        methods: {
          ...mapMutations(["get", "post", "post2"]), //引入方法
          ...mapActions(["act_get_userinfo", "act_sub_coin"]), //引入方法

          show () {
            //切换深色模式
            this.theme_dark = tool.is_theme_dark(this);
            //获取用户信息
            var uid = this.$store.state.uid;
            var self = this;
            self.act_get_userinfo({
                uid: uid,
                success: function (u) {
                    self.user_info = u;
                }
            });
            //获取封号信息
            self.get({
                url:'/App/GetKillInfo/?uid=' + uid,
                success: function(data) {
                    if (data.state == '1') {
                        self.isShowConfirm = true;
                        self.kill_info = data;
                        self.kill_info.pay_coin = 50 * parseInt(self.kill_info.hour)
                    }
                    if (data.state == '0') {
                        self.$store.commit("set_kill_info", "");
                    }
                },
                error: function(res) {}
            });
          },
          hidden () {
            this.isShowConfirm = false;
          },
          unseal () {
            //金币检查
            var pay_coin = this.kill_info.pay_coin;
            if (this.check_coin(pay_coin)) {
                //解封,后台扣除金币
                var kill_id = this.kill_info.kill_id;
                this.sub_coin_unkill(pay_coin, kill_id);
            }
          },
          check_coin(coin_pay) {
            var coin_left = this.user_info.coin_left;
            if (coin_left < coin_pay) {
                //提示金币不足
                this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
                type: "confirm",
                confirmText: "去购买",

                titleText: "温馨提示",
                data: "",
                });
                return false;
            } else {
                return true;
            }
         },
         formact_buycoin(type, data) {
            if (type == "clickConfirm") {
                this.$router.push({ name: "mycoin" });
            }
         },
         sub_coin_unkill(coin_sub, kill_id) {
            var uid = this.$store.state.uid;
            var send_data = {
                uid_from: uid,
                uid_to: "",
                amount: coin_sub,
                type_dtl: "自己花金币解封",
                comment: "",
                rel_id: kill_id,
            };
            var self = this;
            self.act_sub_coin({
                uid: uid,
                strSend: JSON.stringify(send_data),
                success: function (res) {
                 if (res.state == "1") {
                    //扣金币成功
                    self.user_info.coin_left -= coin_sub;
                    //设置解封
                    self.unkill(uid, coin_sub);
                 }
                },
            });
         },
         unkill(uid, coin_sub) {
            var self = this;
            self.get({
                url: "/App/UnKill/?uid=" + uid + "&coin_sub=" + coin_sub,
                success: function (data_serve) {
                if (data_serve.state == "1") {
                    self.$store.commit("set_kill_info", "");
                    self.$toast.center("已解封");
                    self.hidden();
                }
                },
                error: function (err) {},
            });
         },
        }
      }
      </script>

<style lang="scss" scoped>
    .my-confirm {
        position: fixed;
        top: 0;
        left: 0;
        width:100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 990;
        /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    /* 进入和出去的动画 */
    .confirm-fade-enter-active {
        animation: opacity 0.3s;
    }
    .confirm-fade-leave-active {
        animation: outOpacity 0.2s;
    }
     /* 进来的动画 */
    @keyframes opacity {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    /* 出去的动画 */
    @keyframes outOpacity {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    /* 包裹层容器样式 */
    .wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 85%;
        margin: 0 auto;
        z-index: 990;
        user-select: none;
        border-radius: 1rem;
        background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
    }

    /* 顶部标题部分 */
    .title {
        height: 3rem;
        line-height: 3rem;
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        color: #6C1AAB;
    }

    .content {
        padding: 0 0.8rem;
        /* 中间内容部分 */
        .txt {
            min-height: 3rem;
            word-break: break-word;
            font-size: 1em;
            line-height: 1.6em;
            color: #888;
            span {
                color:#f00;
            }
        }
    }

    /* 底部按钮样式 */
    .oper {
        margin: 1.5rem 0;
        .btn {
            margin: 0 0.5rem;
            flex: 1;
            border-radius: 2rem;
        }
        .ok {
            background: linear-gradient( 90deg, #A264E7, #FE9CC0);
        }
        .cancel{
            color: #FFFFFF;
            background-color: #C1C1C1;
        }
        span {
            line-height: 2.6rem;
            color: #fff;
        }
    }

    .container-dark {
        background: linear-gradient(to bottom, #9c365c, #333 3rem);
        .title {
            color: #fff;
        }
        .content {
            .txt {
                color: #e0dbdb;
            }
        }
    }
</style>